"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.81 3.763a2.61 2.61 0 0 1 3.688 0l1.738 1.738a2.61 2.61 0 0 1 0 3.69L10.128 19.297a2.6 2.6 0 0 1-1.212.686l-3.86.965a1.654 1.654 0 0 1-2.006-2.006l.965-3.86c.115-.458.352-.877.686-1.212zm2.698.99a1.21 1.21 0 0 0-1.708 0L5.69 14.862a1.2 1.2 0 0 0-.317.56l-.965 3.86a.254.254 0 0 0 .308.31l3.86-.966c.212-.053.406-.163.561-.318L19.246 8.2a1.21 1.21 0 0 0 0-1.709z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=PencilIcon24.js.map